module.exports = __webpack_public_path__ + "img/오타루11.07a66fc1.jpg";